module.exports = __webpack_public_path__ + "img/kg.094c4395.svg";